<template>
  <div class="timetable">
    <new-timetable />
  </div>
</template>

<script>
import NewTimetable from '../components/timetable/newTimetable.vue'

export default {
  name: 'Timetable',
  title: 'SE-Timetable',

  data() {
    return {}
  },
  components: {
    NewTimetable,
  },
}
</script>
<style lang="scss">
.timtable__head {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
}
</style>
